<template>
  <div class="container">
    <el-container style="height: 100%; border: 1px solid #eee">
      <el-main>
        <div class="blank_content" v-show="askIndex === 0">
          <div class="tips">
            <h1>你好~我是<span>AI小智</span></h1>
            <h3>请问，有什么可以帮助您？ </h3>
            <!-- <h3>我可以帮您智能推荐商品、电站清洗计划、电站资料等，</h3>
            <h3> 或者您有问题也可尽管问我。</h3> -->
          </div>
          <img src="../assets/img/ai_bg.png" class="img_bg"/>
        </div>
        <div id="output"></div>
        <div class="opt_box">
          <div class="input_box">
            <el-input
              ref="input"
              :rows="rows"
              placeholder="请输入聊天内容(按下回车发送,需要换行则按下ctrl+回车)"
              v-model="input"
              @keydown.native="handleKeyDown"
              type="textarea"
              maxlength="2000"
              show-word-limit
            ></el-input>
            <el-button type="primary" @click="sendMessage" :disabled="sendLoading" id="sendBtn">
              <i class="el-icon-s-promotion"></i> 发送
            </el-button>
          </div>
        </div>
      </el-main>
    </el-container>

  </div>
</template>

<script>
import marked from "marked";
import DOMPurify from "dompurify";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import {getsseConnect,chatStreamWithSSE} from '@/api/xunyou'
import axios from 'axios';
export default {
  components: {},
  data() {
    return {
      navShow: true,
      activeConversationsId: '',
      input: "",
      conName: "",
      ctrlAbout: null,
      historyList: [],
      taskId: "",
      messageId: "",
      conversationId: "",
      markdownContent: "", // 流式接收的 Markdown 文本
      htmlContent: "", // 转换后的 HTML
      purifiedHtml: "", // 净化后的安全 HTML
      askIndex: 0, //记录第几轮对话
      sendLoading: false,
      isRecording: false,
      transcript: "",
      volumePercentage: 0,
      messages: [],
      botResponses: [],
      recognition: null,
      audioContext: null,
      analyser: null,
      difyClient: null,
      title: "",
      rows: 4,
      listTotal: [],
      suggested_questions:[],
      generateSessionId:'',
      baseUrl:'',
      eventSource:null,
      waitingResponse:false,
      currentBubble:null,
      bubbleText:'',
    };
  },
  created() {
    this.generateSessionId = 'SID-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
    if(process.env.NODE_ENV === 'test'){
      this.baseUrl = 'http://www.chintyy.com:8088'
      
    } else if(process.env.NODE_ENV === 'production'){
      this.baseUrl = 'https://www.empowerchint.com/center'
    } else {
      // this.baseUrl = 'http://www.chintyy.com:8088'
      this.baseUrl  = 'https://www.empowerchint.com/center'
    }
  },
  mounted() {
    window.aiagentRouter = (id) => {
      // this.$router.push({path:'/goodsdetail?id='+id})
      window.open('/#/goodsdetail?id='+id)
      // this.$emit('closeDrawer')
    }
    this.ctrlAbout = new AbortController();
    this.getgetsseConnect();
  },
  methods: {

    getgetsseConnect() {
        if (this.eventSource) this.eventSource.close();
        this.eventSource = new EventSource( this.baseUrl+'/ai/sseConnect?sessionId='+this.generateSessionId);
        this.eventSource.addEventListener("message", (event) => {
            const data = JSON.parse(event.data || "{}");
            console.log("接收到message:", data);
            if (data.role === "assistant" && data.text&& data.text!=='思考中...') {
                if (!this.currentBubble) {
                    // 首次流式响应创建气泡
                    this.appendMessage("assistant", "", false);
                }
                // 流式打印拼接
                this.appendMessage("assistant", data.text, true);
            }

            if (data.attachments && data.attachments.length > 0) {
              this.appendMessage("attachments", data.attachments);
            }

            // ====== 判断 textComplete 是否为 true ======
            if (data.textComplete === true) {
                this.waitingResponse = false;
                this.toggleSendButton(true);
                // this.appendSystemMessage("✅ AI回复完成，可以继续发送。");
                this.currentBubble = null; // 清空当前气泡
            }
        });

        this.eventSource.addEventListener("end", (event) => {
            const data = JSON.parse(event.data || "{}");
            console.log("收到 end 事件：", data);
            this.waitingResponse = false;
            this.toggleSendButton(true);
            // this.appendSystemMessage("✅ AI回复完成，可以继续发送。");
            this.currentBubble = null; // 清空当前气泡
        });

        this.eventSource.onerror =  (err)=> {
          console.log("连接中断",err);
            this.eventSource.close();
            setTimeout(this.getgetsseConnect, 2000);
        };

        this.eventSource.onopen =  ()=> {
            console.log("🟢 SSE连接成功");
        };
    },
    handleKeyDown(event) {
      // 检查是否同时按下Ctrl键（或Command键）和Enter键
      if ((event.ctrlKey || event.metaKey) && event.key === "Enter") {
        event.preventDefault(); // 阻止默认行为
        console.log("换行");
        // 获取当前光标位置
        const textarea = this.$refs.input.$el.querySelector("textarea");
        const startPos = textarea.selectionStart;
        const endPos = textarea.selectionEnd;
        // 在光标位置插入换行符
        const currentValue = this.input;
        this.input =
          currentValue.substring(0, startPos) +
          "\n" +
          currentValue.substring(endPos);
        this.rows++;
        // 更新光标位置到换行符后
        this.$nextTick(() => {
          textarea.selectionStart = startPos + 1;
          textarea.selectionEnd = startPos + 1;
          textarea.focus();
        });
      } else if (event.key === "Enter") {
        event.preventDefault();
        this.sendMessage();
      } else if (event.key === "Backspace") {
        if (this.rows > this.input.split("\n").length + 1) {
          this.rows--;
        }
      }
    },
    //发送消息
     sendMessage() {
        if (this.waitingResponse) {
            this.$message.warning("请等待AI回复完毕后再发送下一条消息。");
            return;
        }
        if (!this.input) {
          this.$message.warning("请输入要发送的内容");
          return;
        }
        this.rows = 4;
        this.askIndex++;
        this.appendMessage("我", this.input);
        this.waitingResponse = true;
        this.toggleSendButton(false);
        // this.appendSystemMessage("⏳ 等待AI回复中...");
        let myInput = this.input
        this.input = ''//发送后清空输入框
        fetch(this.baseUrl+'/ai/chatStreamWithSSE', {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({ sessionId:this.generateSessionId, text: myInput })
        }).then(resp => {
            if (!resp.ok) {
              this.appendSystemMessage("❌ 发送失败：" + resp.statusText);
                this.waitingResponse = false;
                this.toggleSendButton(true);
            }
        }).catch(err => {
          this.appendSystemMessage("❌ 请求异常：" + err);
            this.waitingResponse = false;
            this.toggleSendButton(true);
        })
    },

     appendMessage(role, text, isStreaming = false) {
        const chatBox = document.getElementById("output");
        const bubble = document.createElement("div");
        if (role === "assistant" && isStreaming && this.currentBubble) {
            const answer = document.getElementById("answer"+this.askIndex);
            answer.textContent += text;
            chatBox.scrollTop = chatBox.scrollHeight;
            return;
        }
        if (role === "我") {
            bubble.innerHTML = `<div class="aiagent_user_ask bubble"><img src="static/img/head2.png" alt=""><div class="aiagent_user_ask_item user">${this.input}</div></div>`
        } else {
            if (role === "assistant") {
              bubble.innerHTML =`<div class="aiagent_user_answer_body bubble assistant">
                <img src="static/img/head.png" alt="">
                <div class="triangle-left"></div>
                <div  class="anwser_item">
                  <div id="answer${this.askIndex}"></div>
                </div>
                </div>`;
              this.currentBubble = bubble; // 保存当前气泡
            }
            if (role === "attachments") {
             
                let list = ''
                text.forEach((item)=>{
                  list+=`<div class="ai_list_box" onclick="aiagentRouter('${item.productId}')"><img class="ai_list_img" src="${item.image}"/><div class="ai_list_name" title="${item.name}">${item.name}</div><div class="ai_list_price">¥ ${item.price}</div></div>`
                })
                bubble.innerHTML =`<div class="aiagent_user_answer_body bubble assistant">
                <img src="static/img/head.png" alt="">
                <div class="triangle-left"></div>
                <div  class="anwser_item">
                  <div id="answer${this.askIndex}">${list}</div>
                </div>
                </div>`;
            }
        }
        chatBox.appendChild(bubble);
        chatBox.scrollTop = chatBox.scrollHeight;
    },

     appendSystemMessage(text) {
        const chatBox = document.getElementById("output");
        const msg = document.createElement("div");
        msg.style.color = "#888";
        msg.style.fontSize = "13px";
        msg.style.textAlign = "center";
        msg.textContent = text;
        chatBox.appendChild(msg);
        chatBox.scrollTop = chatBox.scrollHeight;
    },

     toggleSendButton(enabled) {
        const btn = document.getElementById("sendBtn");
        if (enabled) {
            btn.classList.remove("disabled");
            btn.textContent = "发送";
        } else {
            btn.classList.add("disabled");
            btn.textContent = "等待回复...";
        }
    },


   
  },
};
</script>

<style scoped lang="less">
.container {
  height: 100%;
  background: linear-gradient(60deg, rgba(154, 198, 252, 0.4) 0%, rgba(254, 251, 251, 0.4) 100%);
  .blank_content{
    .tips{
      position: absolute;
      left:10%;
      top: 100px;
      z-index: 999;
      h1{
        font-weight: bold;
        font-size: 34px;
        color: #000000;
        span{
          color:rgba(35, 122, 228, 1);
        }
      }
      h3{
        font-weight: 400;
        font-size: 22px;
        color: #000000;
      }
    }
    .img_bg{
      position: absolute;
      right:0%;
      top: 0;
    }
  }
  #output {
    height: calc(100% - 100px);
    overflow-y: auto;
    overflow-x: hidden;
    text-align: left;
  }
  .opt_box {
    position: absolute;
    z-index: 999;
    bottom: 10px;
    width: 90%;
    left: 4%;
    .stop_btn {
      margin: 0 auto;
      width: 100px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-radius: 4px;
      background: #f0f5fd;
      border: 1px solid #e6e7eb;
      cursor: pointer;
    }
    .input_box {
      display: flex;
      justify-content: space-between;
      background: #fff;
      margin-top: 5px;
      border-radius: 8px;
      padding: 0 12px;
      align-items: end;
      /deep/.el-textarea__inner {
        border: none;
      }
      i {
        font-size: 20px;
      }
      /deep/.el-button--primary{
        border-radius: 20px;
        padding: 9px 20px;
        margin-bottom: 5px;
      }
    }
  }
}
/deep/.el-dialog__header {
  text-align: left;
}
.his_title {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 16px 16px 0;
}
.center_title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
}
.el-main {
  position: relative;
}
.aiagent_dia_opt_box{
  display:flex;
  justify-content: end;
  margin-top: 10px;
}
</style>
<style lang="less">
.user{
  background: #237AE3;
  border-radius: 0px 10px 10px 10px !important;
  margin-left:12px;
  padding:12px 18px;
  color:#fff;
}
.ai_list_box{
  float:left;
  width:200px;
  height:250px;
  margin-right:16px;
  background: #F1F2F5;
  padding:16px;
  margin-bottom:16px;
  cursor: pointer;
  .ai_list_img{
    width:200px;
    height:200px;
  }
  .ai_list_name{
    font-size: 14px;
    color: #040000;
    line-height: 36px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width:100%;
  }
  .ai_list_price{
    font-size: 14px;
    font-weight: bold;
    color: #E83339;
    line-height: 25px;
  }
}
.aiagent_user_answer_body {
  display: flex;
  img {
    width: 32px;
    height: 32px;
  }
}
.triangle-left {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 10px solid #ffffff; /* 这里的颜色可以更改 */
  margin-left: 10px;
  margin-top: 10px;
}
.triangle-right {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  // border-left: 10px solid @Ccolor; /* 这里的颜色可以更改 */
  margin-right: 10px;
  margin-top: 0px;
}
.agent_ans_opt_body {
  border-top: 1px solid #e6e7eb;
  margin-top: 10px;
  padding: 8px;
  .agent_ans_opt_item {
    display: flex;
    justify-content: right;
    img {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
.suggess_list{
  margin-top:10px;
  .suggess_item{
    // color:@Ccolor;
    border:1px solid #E6E7EB;
    border-radius:4px;
    padding:8px;
    cursor: pointer;
    display: inline-block;
    width:auto;
  }
}
.aiagent_user_ask {
  box-sizing: border-box;
  align-items: center;
  margin-bottom: 16px;
  margin-right: 15px;
  display: flex;
  right: -12px;
  overflow-y: hidden;
  justify-content: left;
  .aiagent_user_ask_item {
    border-radius: 14px;
    // background-color: @Ccolor;
    color: #ffffff;
    padding: 10px;
  }
}
.anwser_item {
  text-align: left;
  margin-bottom: 16px;
  width: 90%;
  background-color: #ffffff;
  padding: 12px;
  border-radius: 8px;
}
#thinking {
  text-align: left;
  animation: blink 1s infinite;
}
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aiagentBox.vue